<template>
  <div class="col-sm-12">
    <h3 class="title">Reporte de Salarios</h3>
    <div class="card">
      <div class="card-header">
        <div class="row">
            <div class="col-md-3">
                <input class="form-control" placeholder="Buscar..." v-model="search"/>
            </div>
            <div class="col-md-2">

            </div>
            <div class="col-md-3" style="text-align: right;">
                <select class="form-select" v-model="employerSelect" style="float: right;" @change="changeFilters">
                    <option v-for="(employer, index) in employers" :key="index" :value="employer.id">{{ employer.name }}</option>
                </select>
            </div>
            <div class="col-md-3">
              <select class="form-select" v-model="periodSelect" style="float: right;" @change="changeFilters">
                  <option v-for="(period, index) in periods" :key="index" :value="period.id">{{ period.name }}</option>
              </select>
            </div>
            <div class="col-md-1">
              <button class="btn btn-info btn-sm" @click="loadEmployees(filteredEmployees)" type="button" style="float: right; width: 120px; height: 37px;" title="btn btn-success btn-sm"  data-bs-toggle="modal" data-bs-target=".employee-export-modal">Exportar</button>
            </div>
        </div>        
      </div>
      <div style="overflow-x: auto; max-width: 100%;">
        <table class="table">
          <thead>
            <tr class="border-bottom-danger header">
              <th class="sticky-col">Nombre</th>
              <th class="money" scope="col">Antigüedad</th>
              <th class="money" scope="col">Salario Total</th>
              <th class="money" scope="col">Salario Fiscal</th>
              <th class="money" scope="col">SD</th>
              <th class="money" scope="col">SDI</th>
              <th class="center" scope="col">Días Trabajados</th>
              <th class="center" scope="col">Faltas</th>
              <th class="money" scope="col">Subsidio</th>
              <th class="money" scope="col">Días de Vacaciones</th>
              <th class="money" scope="col">Prima Vacacional</th>
              <th class="money" scope="col">ISR</th>
              <th class="money" scope="col">IMSS</th>
              <th class="money" scope="col">Infonavit</th>
              <th class="money" scope="col">Fonacot</th>
              <th class="money" scope="col">Bono</th>
              <th class="center" scope="col">Sueldo<br />Fiscal</th>
              <th class="center" scope="col">Sueldo<br />Complementario</th>
              <th class="center" scope="col">Sueldo<br />Final</th>
              <th class="center" scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr :class="index % 2 == 0 ? 'border-bottom-warning' : 'border-bottom-danger'" v-for="(employee, index) in filteredEmployees" :key="index">
              <td class="sticky-col">
                {{ employee.rfc }}<br /><span style="font-weight: bold;"><a href="javascript:;" @click="">{{ employee.name }}</a></span><br />{{ employee.job_position }}
              </td>
              <td class="money">{{ employee.age }}</td>
              <td class="money">{{ $formatCurrency(employee.final_wage+"") }}</td>
              <td class="money">{{ $formatCurrency((employee.daily_salary * employee.work_days)+"") }}</td>
              <td class="money">{{ $formatCurrency(employee.daily_salary+"") }}</td>
              <td class="money">{{ $formatCurrency(employee.integral_daily_salary+"") }}</td>
              <td class="center">{{ employee.work_days }}</td>
              <td class="center"><a href="javascript:;" @click="loadEmployeeAbsences(employee, 'absences')" data-bs-toggle="modal" data-bs-target=".employee-absence-modal">{{ employee.absences }}</a></td>
              <td class="money">{{ $formatCurrency(employee.subsidio+"") }}</td>
              <td class="center"><a href="javascript:;" @click="loadEmployeeAbsences(employee, 'vacations')" data-bs-toggle="modal" data-bs-target=".employee-absence-modal">{{ employee.vacations }}</a></td>
              <td class="money">{{ $formatCurrency(employee.vacation_bonus+"") }}</td>
              <td class="money">{{ $formatCurrency(employee.isr+"") }}</td>
              <td class="money">{{ $formatCurrency(employee.imss+"") }}</td>
              <td class="money"><a href="javascript:;" @click="loadEmployee(employee)" data-bs-toggle="modal" data-bs-target=".employee-infonavit-modal">{{ $formatCurrency(employee.infonavit+"") }}</a></td>
              <td class="money"><a href="javascript:;" @click="loadEmployee(employee)" data-bs-toggle="modal" data-bs-target=".employee-fonacot-modal">{{ $formatCurrency(employee.fonacot+"") }}</a></td>
              <td class="money"><a href="javascript:;" @click="loadEmployee(employee)" data-bs-toggle="modal" data-bs-target=".employee-bono-modal">{{ $formatCurrency(employee.bono_amount+"") }}</a></td>
              <td class="money">{{ $formatCurrency(employee.net_fiscal+"") }}</td>
              <td class="money">{{ $formatCurrency(employee.net_complementary+"") }}</td>
              <td class="money">{{ $formatCurrency(employee.net_final+"") }}</td>
              <td>
                <button v-if="!employee.payroll" class="btn btn-primary btn-sm"@click="loadEmployee(employee)" type="button" style="float: right; width: 120px;" title="btn btn-success btn-sm"  data-bs-toggle="modal" data-bs-target=".employee-payroll-modal">Timbrar</button>
                <button v-if="employee.payroll" class="btn btn-secondary btn-sm"@click="loadEmployee(employee)" type="button" style="float: right; width: 120px;" title="btn btn-success btn-sm"  data-bs-toggle="modal" data-bs-target=".employee-payroll-modal">Ver Recibo</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer"></div>
    </div>
      <div class="modal fade employee-absence-modal" tabindex="-1" role="dialog" aria-labelledby="absenceEmployeeModalLabel" aria-hidden="true">
          <EmployeeAbsenceModal ref="employeeAbsenceModal" :employees="employees" @refresh="refreshEmployees" />
      </div>
      <div class="modal fade employee-infonavit-modal" tabindex="-1" role="dialog" aria-labelledby="infonavitEmployeeModalLabel" aria-hidden="true">
          <EmployeeInfonavitModal ref="employeeInfonavitModal" @refresh="refreshEmployees" />
      </div>
      <div class="modal fade employee-fonacot-modal" tabindex="-1" role="dialog" aria-labelledby="fonacotEmployeeModalLabel" aria-hidden="true">
          <EmployeeFonacotModal ref="employeeFonacotModal" @refresh="refreshEmployees" />
      </div>
      <div class="modal fade employee-bono-modal" tabindex="-1" role="dialog" aria-labelledby="bonoEmployeeModalLabel" aria-hidden="true">
          <EmployeeBonoModal ref="employeeBonoModal" @refresh="refreshEmployees" />
      </div>
      <div class="modal fade employee-payroll-modal" tabindex="-1" role="dialog" aria-labelledby="payrollEmployeeModalLabel" aria-hidden="true">
          <EmployeePayrollModal ref="employeePayrollModal" :employees="employees" @refresh="refreshEmployees" />
      </div>
      <div class="modal fade employee-detailed-modal" tabindex="-1" role="dialog" aria-labelledby="detailedEmployeeModalLabel" aria-hidden="true">
          <EmployeeDetailedModal ref="employeeDetailedModal" @refresh="refreshEmployees" />
      </div>
      <div class="modal fade employee-export-modal" tabindex="-1" role="dialog" aria-labelledby="exportEmployeeModalLabel" aria-hidden="true">
          <EmployeeExportModal ref="employeeExportModal" @refresh="refreshEmployees" />
      </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import getImage from "@/mixins/getImage"

import EmployeeAbsenceModal from "@/components/tmkt/employees/employee_absence_modal.vue"
import EmployeeInfonavitModal from "@/components/tmkt/employees/employee_infonavit_modal.vue"
import EmployeeFonacotModal from "@/components/tmkt/employees/employee_fonacot_modal.vue"
import EmployeeBonoModal from "@/components/tmkt/employees/employee_bono_modal.vue"
import EmployeePayrollModal from "@/components/tmkt/employees/employee_payroll_modal.vue"
import EmployeeDetailedModal from "@/components/tmkt/employees/employee_detailed_modal.vue"
import EmployeeExportModal from "@/components/tmkt/employees/employee_export_modal.vue"

import ws from '@/services/employees'

export default {
  components: {
      EmployeeAbsenceModal,
      EmployeeInfonavitModal,
      EmployeeFonacotModal,
      EmployeeBonoModal,
      EmployeePayrollModal,
      EmployeeDetailedModal,
      EmployeeExportModal
  },
  mixins: [getImage],
  data(){
      return{
          employees: null,
          periods: [],
          periodSelect: "20240501",
          lastPeriod: "20240501",
          search: "",
          employers: null, 
          employerSelect: 0,
          lastEmployer: 0,
      }
  },
  mounted: async function() {
      let response = await ws.getPeriods(); 

      if(response.type == "success"){
          this.periods = response.data;

          this.periodSelect = this.periods[0].id;
      }

      let response2 = await ws.getEmployers(); 

      if(response2.type == "success"){
          this.employers = response2.data;

          this.employerSelect = this.employers[0].id;
      }

      this.changeFilters();
  },
  methods: {
    async changeFilters () {
      let flag = false;

      if(this.lastPeriod != this.periodSelect){
        flag = true;

        this.lastPeriod = this.periodSelect;
      }

      if(this.lastEmployer != this.employerSelect){
        flag = true;

        this.lastEmployer = this.employerSelect;
      }

      let filters = {
        period : this.periodSelect,
        employer_id: this.employerSelect,
        fiscal_salary: true
      };

      let response = await ws.getEmployeesFilteredWithPayroll(filters);

      if(response.type == "success"){
        this.employees = response.data;
      }
    },

    async loadEmployee (employee) {
      this.$refs.employeeInfonavitModal.loadEmployee(employee);
      this.$refs.employeeFonacotModal.loadEmployee(employee);
      this.$refs.employeeBonoModal.loadEmployee(employee);
      this.$refs.employeePayrollModal.loadEmployee(employee, this.periodSelect);
      this.$refs.employeeDetailedModal.loadEmployee(employee);
    },

    async loadEmployeeAbsences (employee, type) {
      this.$refs.employeeAbsenceModal.loadEmployee(employee, type);
    },
    async loadEmployees (employees) {
      this.$refs.employeeExportModal.loadData(employees, this.periodSelect);
    },
    
    async refreshEmployees () {
      let filters = {
        period : this.periodSelect,
        employer_id: this.employerSelect,
        fiscal_salary: true
      };

      let response = await ws.getEmployeesFilteredWithPayroll(filters);

      if(response.type == "success"){
        this.employees = response.data;

        this.$refs.employeeAbsenceModal.clearForm();
      }
    },
  },  
  computed: {
    ...mapState({
      bootstraplist: state => state.bootsrap.bootstrap,
      inverselist: state => state.bootsrap.inverse
    }),
    filteredEmployees(){
        if(this.search == ''){
            return this.employees;
        }

        let query = this.search.toLowerCase();

        return this.employees.filter(item => item.name.toLowerCase().includes(query));
    }
  },
}
</script>
<style>
  .table{
    td{
      vertical-align: middle;
    }
    
    .money{
      text-align: right;
    }

    .center{
      text-align: center;
    }
  }

  .table-responsive {
    overflow-x: auto;
    max-width: 100%;
  }

  .table-responsive .table {
    min-width: 1000px; /* o el valor que necesites para evitar columnas apretadas */
    border-collapse: collapse;
  }

  .table th,
  .table td {
    padding: 8px 12px;
    white-space: nowrap; /* Evita que el texto se rompa */
  }

  .sticky-col {
    position: sticky;
    left: 0;
    background-color: #F9F9F9 !important; /* o el color de fondo que tengas */
    z-index: 2;
  }
</style>